import { render, staticRenderFns } from "./hangYe.vue?vue&type=template&id=25ec4652&scoped=true"
import script from "./hangYe.vue?vue&type=script&lang=js"
export * from "./hangYe.vue?vue&type=script&lang=js"
import style0 from "./hangYe.vue?vue&type=style&index=0&id=25ec4652&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ec4652",
  null
  
)

export default component.exports